import Vue from "vue"
import Vuex from "vuex"
import config from "./config" 

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
      // deyisenleri global olanlari burada teyin edirik
      mini: false
    },
    mutations : {
        // mutationun isi state deyerini deyismekdi
        // ---------------------------
        // initState(state, items){
        //     state.items = items
        // }
        // ---------------------------
        initMini(state, mini){
          state.mini = mini
        }
    },
    actions : {
      // asenkron olaraq alacaqimiz islerde database api falan bunu istifade edeceyik
      updateMini(context, mini) {
        context.commit('initMini', mini)
        localStorage.setItem('mini', mini);
      }
    },
    getters : {
      // state icindeki datayi bize geri dondurur
      // ----------------------------
      // getState(state){
      //     return state.items
      // }
      // ----------------------------
      // istifade seklidi de buna benzerdir parametre olaraq state alir ve oda yuxarida gosterilen state gosterik
      getMini(state) {
        if (localStorage.getItem('mini') === null) {
          localStorage.setItem('mini', false)
        }
        else {
          config.dispatch('updateMini', localStorage.getItem('mini') === 'true')
        }
          
        return state.mini
      }
    }
})
